import { Brain } from 'lucide-react'
import { Menu } from '@highlight/ui'
import { copyTextToClipboard } from '@renderer/utils/clipboard'
import { useCanViewBraintrustLinks } from './braintrust-span-link'

interface BraintrustLinkMenuItemProps {
  link: string | null | undefined
}

/**
 * Ungated (the caller decides who sees it), for menus with a fixed Braintrust
 * slot (Help): a missing link shows disabled rather than vanishing, so the
 * slot doesn't look broken.
 */
export function BraintrustLinkMenuItem({ link }: BraintrustLinkMenuItemProps) {
  if (!link) {
    return (
      <Menu.Item disabled>
        <Brain />
        <span>No Braintrust link found</span>
      </Menu.Item>
    )
  }

  return (
    <Menu.Item onClick={() => void copyTextToClipboard(link)}>
      <Brain />
      <span>Copy Braintrust link</span>
    </Menu.Item>
  )
}

/** Staff-only. Works in context menus too: base-ui's `ContextMenu.Item` is its `Menu.Item`. */
export function CopyBraintrustLinkMenuItem({ link }: BraintrustLinkMenuItemProps) {
  const canViewBraintrustLinks = useCanViewBraintrustLinks()
  if (!canViewBraintrustLinks || !link) return null

  return <BraintrustLinkMenuItem link={link} />
}
